import { render, staticRenderFns } from "./HistoryWithdrawOff.vue?vue&type=template&id=71b6e063&scoped=true&"
import script from "./HistoryWithdrawOff.vue?vue&type=script&lang=js&"
export * from "./HistoryWithdrawOff.vue?vue&type=script&lang=js&"
import style0 from "./HistoryWithdrawOff.vue?vue&type=style&index=0&id=71b6e063&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b6e063",
  null
  
)

export default component.exports